
import React, {useEffect, useRef} from 'react'
import { Row } from "antd";
import { TeamOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

const PurposeCommit3 = () => {
    const serviceRef = useRef(null)
    useEffect(() => {
        
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('fadeInLeft3')
              }
            })
          },
          {
            threshold: 0.5
          }
        )

        const serviceRefCurrent = serviceRef.current
    
        if (serviceRefCurrent) {
          observer.observe(serviceRefCurrent)
        }
    
        return () => {
          if (serviceRefCurrent) {
            observer.unobserve(serviceRefCurrent)
          }
        }
      
    }, [])

    return (
        <>
            <StyledDiv
                style={{
                    marginTop: "20px"
                }}
                className='landingCommitmentText'
                ref={serviceRef}
            >
                <Row justify="start">
                    <TeamOutlined className="landingCommitmentIcon" />
                    <label style={{
                      marginTop: "4px"
                    }}>Protecting the Employee</label>
                </Row>
                {/* <label>•	Protecting the Employee</label> */}
            </StyledDiv>
        </>
    )
}

export default PurposeCommit3
